<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px" v-if="type=='wxapp'">
      <!--小程序设置-->
      <div class="common-form">小程序设置</div>

      <el-form-item label="名字">
        <el-input v-model="form.port_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppID 小程序ID">
        <el-input v-model="form.wxapp_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret 小程序密钥">
        <el-input v-model="form.wxapp_secret" type="password" class="max-w460"></el-input>
      </el-form-item>


      <div class="common-form">微信支付设置</div>

     <el-form-item label="支付方式">
             <el-select
               v-model="form.payment_id"
               multiple
               style="width: 400px"
               placeholder="请选择"
             >
               <el-option
                 v-for="(item, index) in paymentList"
                 :key="index"
                 :label="item.name"
                 :value="item.payment_id"
               >
               </el-option>
             </el-select>
           </el-form-item>

     <!-- <el-form-item label="微信支付商户号 MCHID">
        <el-input v-model="form.mchid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="微信支付密钥 APIKEY ">
        <el-input v-model="form.apikey" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="apiclient_cert.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.cert_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
      <el-form-item label="apiclient_key.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.key_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
 -->
      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>


     <el-form size="small" ref="form" :model="form" label-width="250px" v-else-if="type=='wxmp'">
      <!--公众号设置-->
      <div class="common-form">公众号设置</div>

       <el-form-item label="名字">
        <el-input v-model="form.port_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppID 公众号ID">
        <el-input v-model="form.mpapp_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret 公众号密钥">
        <el-input v-model="form.mpapp_secret" type="password" class="max-w460"></el-input>
      </el-form-item>


      <div class="common-form">微信支付设置</div>

      <el-form-item label="支付方式">
              <el-select
                v-model="form.payment_id"
                multiple
                style="width: 400px"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in paymentList"
                  :key="index"
                  :label="item.name"
                  :value="item.payment_id"
                >
                </el-option>
              </el-select>
            </el-form-item>

      <!-- <el-form-item label="微信支付商户号 MCHID">
        <el-input v-model="form.mchid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="微信支付密钥 APIKEY ">
        <el-input v-model="form.apikey" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="apiclient_cert.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.cert_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item>
      <el-form-item label="apiclient_key.pem">
        <el-input type="textarea" :rows="4" placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来" v-model="form.key_pem" class="max-w460"></el-input>
        <div class="tips">使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来</div>
      </el-form-item> -->

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>

    <el-form v-else label-width="250px" size="small" :model="form">
      <!--H5设置-->
      <div class="common-form">H5设置</div>

      <el-form-item label="名字">
        <el-input v-model="form.port_name" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="站点">
        <el-input v-model="form.app_id" class="max-w460"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="supply_id">
        <el-input v-model="form.supply_id" class="max-w460"></el-input>
      </el-form-item> -->
      <el-form-item label="logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload()">选择图片</el-button>
          <div v-if="form.logo!=''" class="img">
            <img :src="form.logo" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <div class="common-form">微信支付设置</div>

      <el-form-item label="支付方式">
              <el-select
                v-model="form.payment_id"
                multiple
                style="width: 400px"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in paymentList"
                  :key="index"
                  :label="item.name"
                  :value="item.payment_id"
                >
                </el-option>
              </el-select>
            </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
    <!-- <el-form v-else>
      请联系管理员添加
    </el-form> -->

  </div>

</template>

<script>
  import PortApi from '@/api/port.js';
  import SettingApi from "@/api/setting.js";

  export default {
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        type:'wxapp',
        payment_list:{
          balance: '余额支付',
          alipay: '支付宝支付',
          wechatpay: '微信支付',
          unionpay: '银联支付'
        },
        paymentList: [],
        auth_type:0,
        /*form表单数据*/
        form: {
        },


      };
    },
    created() {
      this.type = this.$route.query.type;
      this.port_id = this.$route.query.port_id;
      this.auth_type = this.$route.query.auth_type;
      // this.getData()
      if (this.port_id) {
          this.getData();
      }
      this.getPayList();
    },

    methods: {
      getData() {
        let self = this;
      let params = {};
      params.port_id = self.port_id;
      params.type = self.type;
      params.auth_type = self.auth_type;
      if (self.type == "wxapp" || self.type == "wxmp") {
        PortApi.detail(params, true)
          .then((data) => {
            console.log(data);
            this.form = data.data.data;
            if (data.data.data != null && data.data.data != []) {
              self.form = data.data.data;
            }
          })
          .catch((error) => {});
      } else {
        PortApi.detailOther({ port_id: this.port_id }, true)
          .then((data) => {
            if (data.data.data != null && data.data.data != []) {
              self.form = data.data.data;
            }
          })
          .catch((error) => {});
      }
      },
       // 获取支付方式
      getPayList() {
        let Params = {};
        Params.page = 1;
        Params.list_rows = 500;
        SettingApi.paymentList(Params, true)
          .then((data) => {
            console.log("支付方式",data);
            this.paymentList = data.data.list.data;
          })
          .catch((error) => {});
      },
      //提交表单
      onSubmit() {
        let self = this;
        //let params = this.form;
        let params = this.form
        params.type = self.type;
        params.port_id = self.port_id;
        params.logo = this.form.logo;
        params.auth_type = self.auth_type;
      //   if (self.type == "wxapp" || self.type == "wxmp") {
      //   let params = this.form;
      //   params.port_id = self.port_id;
      //   params.type = self.type;
      //   params.auth_type = self.auth_type;
      //   params.logo = this.form.logo
      //   PortApi.add(params, true)
      //     .then((data) => {
      //       self.$message({
      //         message: "恭喜你，设置成功",
      //         type: "success",
      //       });
      //       self.$router.push("/plus/port/port/index");
      //     })
      //     .catch((error) => {});
      // } else {
        // let params = {};
        // params.port_name = this.form.port_name;
        // //params.app_id = this.form.app_id; // 站点
        // params.payment_id = this.form.payment_id; // 支付方式
        // params.type = this.type;
        // params.auth_type = this.auth_type;
        // params.port_id = this.port_id;
        // params.logo = this.form.logo
        // params.supply_id = this.form.supply_id
        PortApi.addOther(params, true)
          .then((data) => {
            self.$message({
              message: "恭喜你，设置成功",
              type: "success",
            });
            self.$router.push("/plus/port/port/index");
          })
          .catch((error) => {});
      //}





        // params.port_id = self.port_id;
        // params.type = self.type;
        // params.auth_type = self.auth_type;
        // if(self.type=='wxapp'||self.type=='wxmp'){

        //   PortApi.add(params, true)
        //   .then(data => {
        //     self.$message({
        //       message: '恭喜你，设置成功',
        //       type: 'success'
        //     });
        //     self.$router.push('/plus/port/port/index');
        //   })
        //   .catch(error => {

        //   });
        // }else{
        //   self.$message({
        //     message: '请联系管理员处理',
        //     type: 'error'
        //   });
        // }

      },
    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/port/port/add.vue